export const homepage = "/api/v1/Home";
export const homepageCat = "/api/v1/Home/GetPropertiesByPropertyType";
export const newspagelist = "/api/v1/Blogs";
export const newspagedetail = "/api/v1/Blogs/Details";
export const career = "/api/v1/Careers/OpenPositions";
export const careerapply = "/api/v1/Careers/Apply";
export const developer = "/api/v1/Developers";
export const offer = "/api/v1/Offers";
export const developerproject = "/api/v1/Developers/GetProjectsByDeveloper";
export const developerprojectproperty = "/api/v1/Properties";
export const propertydetail = "/api/v1/Properties/Details";
export const contactdetails = "/api/v1/Contact/Inquire";
export const areasdetails = "/api/v1/Areas/Details";
export const propertysearch = "/api/v1/Search/PropertySearch";
export const searchfilters = "/api/v1/Search/Filters";
export const projectslatlong = "/api/v1/Projects/GetProjectsLatLong";
export const localization = "/api/v1/Localization/Localized-Content"
export const verifycaptcha = "/api/v1/Contact/verify-captcha"
export const staticpages = "/api/v1/Pages"
export const footersection = "/api/v1/site-settings"
export const propertyCount = "/api/v1/Search/PropertyCount";
export const cmsfranchise = "/api/v1/cms-pages/Franchise";
export const cmsfreelancer = "/api/v1/cms-pages/Freelancer";
export const cmscareer = "/api/v1/cms-pages/Career";


export const defaultAmenities = {
    1: { label: "clubhouse", image: "/assets/img/club.svg" },
    2: { label: "schools", image: "/assets/img/school-icon.svg" },
    3: { label: "commercial_strip", image: "/assets/img/commercial-icon.svg" },
    4: { label: "sports_clubs", image: "/assets/img/sports-icon.svg" },
    5: { label: "mosque", image: "/assets/img/mosque-icon.svg" },
    6: { label: "bicycles_lanes", image: "/assets/img/bicycles-icon.svg" },
}
export const defaultPropertyType = {
    1: { label: "apartment", image: "/assets/img/apartment.svg" },
    // 2: { label: "bungalow", image: "/assets/img/bungalow.svg" },
    2: { label: "service_apartments", image: "/assets/img/bungalow.svg" },
    3: { label: "duplex", image: "/assets/img/duplex.svg" },
    4: { label: "penthouse", image: "/assets/img/penthouse.svg" },
    5: { label: "villa", image: "/assets/img/Villa.svg" },
    6: { label: "office", image: "/assets/img/office.svg" },
    7: { label: "clinic", image: "/assets/img/clinic.svg" },
    8: { label: "studio", image: "/assets/img/studio.svg" },
    9: { label: "chalet", image: "/assets/img/chalet.svg" },
    10: { label: "retail", image: "/assets/img/retail.svg" },
    11: { label: "twinhouse", image: "/assets/img/twinhouse.svg" },
    12: { label: "townhouse", image: "/assets/img/townhouse.svg" },
}

export const ProjectStatus = {
    1: { label: "planned" },
    2: { label: "upcoming" },
    3: { label: "ongoing" },
    4: { label: "completed" },
}

export const PropertySaleTypes = {
    1: { label: "off_plan" },
    2: { label: "resale" },
}